<template>
  <div>
    <section>
      <div class="modal-card" style="width: auto" id="modal-event">
        <header class="modal-card-head">
          <p class="modal-card-title">{{modalHeader}}</p>
          <button
              type="button"
              class="delete"
              @click="$emit('close')"/>
        </header>
        <section class="modal-card-body">
          <nullified_show_patent :cargo-principal="cargoPrincipal" :patent-id="patentId">
          </nullified_show_patent>
        </section>
      </div>
    </section>

    <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false"></b-loading>
  </div>
</template>

<script>
import nullified_show_patent from "./nullified_show_patent";
export default {
  name: "modal_show_nullified_patent",
  components: {
    nullified_show_patent
  },
  props:[
    'modalHeader','cargoPrincipal', 'patentId'
  ],
  data(){
    return{
      isLoading: false
    }
  },
}
</script>
